module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.mostrarMensagem === 'SIM') ? _c('div', {
    staticClass: "alert alert-dismissible alert-warning",
    attrs: {
      "id": "quandroAviso"
    }
  }, [_c('h4', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("COMUNICADO FBB")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.mensagem)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pagina-login pagina-novembro-azul"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "login-logo yellow-bg"
  }, [_c('router-link', {
    staticClass: "marca-novembro-azul",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "marca",
    attrs: {
      "src": "/static/img/logo-login.png",
      "alt": "Fundação BB"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "laco",
    attrs: {
      "src": "/static/img/laco-novembro-azul.svg",
      "alt": "Novembro Azul",
      "title": "Novembro Azul: prevenção ao câncer de próstata"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "login-box-body"
  }, [_c('p', {
    staticClass: "login-box-msg"
  }, [_vm._v("Entre com suas credenciais")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      },
      "keydown": function($event) {
        return _vm.form.onKeydown($event)
      }
    }
  }, [(_vm.error) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group required",
    class: {
      'has-error': _vm.form.errors.has('ds_login')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.ds_login),
      expression: "form.ds_login"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Informe seu Login ou E-mail",
      "name": "usuario"
    },
    domProps: {
      "value": (_vm.form.ds_login)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "ds_login", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "ds_login"
    }
  }), _vm._v(" "), (_vm.errors.first('usuario')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('usuario')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group required",
    class: {
      'has-error': _vm.form.errors.has('senha')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.senha),
      expression: "senha"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'input': true, 'is-danger': _vm.errors.has('senha')
    },
    attrs: {
      "type": "password",
      "placeholder": "Senha",
      "name": "senha"
    },
    domProps: {
      "value": (_vm.senha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.senha = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first('senha')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('senha')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary-login btn-block btn-flat",
    attrs: {
      "disabled": _vm.form.busy,
      "type": "submit"
    }
  }, [_vm._v("Acessar")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('vue-snotify'), _vm._v(" "), _vm._m(2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    attrs: {
      "id": "recupera-senha",
      "href": "/esqueci-minha-senha"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#465eff",
      "font-weight": "bold"
    }
  }, [_vm._v("Esqueci minha senha")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    attrs: {
      "id": "recupera-senha-msg",
      "href": "\\static\\img\\help_senha_sgp.jpg",
      "target": "_"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#465eff"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Como recuperar minha senha?")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "white",
      "text-align": "center",
      "padding": "10px",
      "background-color": "#465eff",
      "width": "360px",
      "margin": "0 auto 0 auto"
    }
  }, [_c('p', [_vm._v("Ao acessar o SGP, você está concordando com o "), _c('a', {
    staticStyle: {
      "color": "#fff",
      "font-weight": "bold",
      "text-decoration": "underline"
    },
    attrs: {
      "target": "_blank",
      "href": "https://fbb.org.br/wp-content/uploads/2024/11/Programa_de_Compliance_e_Integridade_Fundacao_BB.pdf"
    }
  }, [_vm._v("Programa de "), _c('i', [_vm._v("Compliance")]), _vm._v(" e Integridade")]), _vm._v(" e o "), _c('a', {
    staticStyle: {
      "color": "#fff",
      "font-weight": "bold",
      "text-decoration": "underline"
    },
    attrs: {
      "target": "_blank",
      "href": "https://fbb.org.br/wp-content/uploads/2024/11/Codigo_de_Etica_Fundacao_BB.pdf"
    }
  }, [_vm._v("Código de Ética")]), _vm._v(" da Fundação BB.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-442feb99!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 1930
// module chunks = 1